import cx from "classnames";
import styles from "./index.module.scss";

export default ({ className, ...rest }) => (
  <svg
    {...rest}
    className={cx(styles.main, className)}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m8 0 1.41 1.41L3.83 7H16v2H3.83l5.58 5.59L8 16 0 8l8-8Z"
      fill="currentColor"
    />
  </svg>
);
